import { render, staticRenderFns } from "./scoreEntryDialog.vue?vue&type=template&id=639dfd57&scoped=true"
import script from "./scoreEntryDialog.vue?vue&type=script&lang=js"
export * from "./scoreEntryDialog.vue?vue&type=script&lang=js"
import style0 from "./scoreEntryDialog.vue?vue&type=style&index=0&id=639dfd57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639dfd57",
  null
  
)

export default component.exports